'use strict';

var dragula = require('dragula');


module.exports = ['dragulaService', function (dragulaService) {
    return {
        restrict: 'A',
        scope: {
            dragulaOptions: '='
        },
        controller: ["$scope", "$timeout", function ($scope, $timeout) {
            this.addContainer = function (scope, el, attrs) {
                var model = scope.dragulaModel;
                var container = el[0];
                var bag = dragulaService.find($scope, $scope.name);

                if (bag) {
                    bag.drake.containers.push(container);
                    if (model) {
                        if (bag.drake.models) {
                            bag.drake.models.push(model);
                        } else {
                            bag.drake.models = [model];
                        }
                    }
                }
            };
        }],
        link: link
    };

    function link(scope, elem, attrs) {

        scope.$watch("dragulaOptions", function(){

            scope.name = scope.$eval(attrs.pdDragula);

            var bag = dragulaService.find(scope, scope.name);

            if(bag){
                dragulaService.destroy(scope, scope.name);
            }

            var defaults = {};
            var options = angular.extend({}, defaults, scope.dragulaOptions);

            var drake = dragula(options);

            dragulaService.add(scope, scope.name, drake);

            handleModels(scope, drake);
        });
    }

    function handleModels(scope, drake) {
        var dragElm;
        var dragIndex;
        var dropIndex;
        var sourceModel;
        drake.on('remove', function removeModel(el, source) {
            sourceModel = drake.models[drake.containers.indexOf(source)];
            scope.$applyAsync(function applyRemove() {
                sourceModel.splice(dragIndex, 1);
                drake.emit('remove-model', el, source);
            });
        });
        drake.on('drag', function dragModel(el, source) {
            dragElm = el;
            dragIndex = domIndexOf(el, source);
        });
        drake.on('drop', function dropModel(dropElm, target, source) {
            dropIndex = domIndexOf(dropElm, target);
            scope.$applyAsync(function applyDrop() {
                sourceModel = drake.models[drake.containers.indexOf(source)];
                if (target === source) {
                    sourceModel.splice(dropIndex, 0, sourceModel.splice(dragIndex, 1)[0]);
                } else {

                    var notCopy = dragElm === dropElm;
                    var targetModel = drake.models[drake.containers.indexOf(target)];
                    var dropElmModel = notCopy ? sourceModel[dragIndex] : angular.copy(sourceModel[dragIndex]);

                    if (notCopy) {
                        sourceModel.splice(dragIndex, 1);
                    }
                    targetModel.splice(dropIndex, 0, dropElmModel);
                    target.removeChild(dropElm); // element must be removed for ngRepeat to apply correctly
                }
                drake.emit('drop-model', dropElm, target, source);
            });
        });
    }

    function domIndexOf(child, parent) {
        return Array.prototype.indexOf.call(angular.element(parent).children(), child);
    }

}];
